<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                <section class="mu-d-flex">
                    <h1 class="mu-mb-00">Users</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p>
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Users & groups</li>
                <li>
                    <router-link :to="CONTEXT_PATH + '/usersgroups/users'">Users
                    </router-link>
                </li>
                <li>Import users</li>
            </ol>
        </nav>
        <div class="mcc-row">
            <div class="mcc-col">
                <div style="position:relative">
                    <div v-if="!updateCall" class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                    <Drawer ref="customFilter" @reset-filter="resetForm" @apply-filter="submitFilterDialog($event)" title="User Filters">
                       
                            <section>
                                <div class="mcc-row">
                                    <div class="mcc-col">
                                        <form id="formIdd">
                                        <div>
                                            <div class="mt-2">
                                                <div class="mcc-segmented-buttons mcc-segmented-buttons--sm mu-mb-05 mfc-form-input-container">
                                                    <fieldset class="mfc-fieldset">
                                                        <legend class="mfc-label">
                                                            User Type
                                                        </legend>
                                                        <div class="mcc-segmented-buttons__list ">
                                                            <input type="radio" name="existing" value="existing" id="existing" @click="filterUserType = $event.target.value" :checked="filterUserType =='existing'">
                                                            <label class="mcc-segmented-buttons__button" for="existing">
                                                                <span class="mcc-segmented-buttons__label">Existing</span>
                                                            </label>
                                                            <input type="radio" name="new" id="new" value="new" @click="filterUserType = $event.target.value" :checked="filterUserType =='new'">
                                                            <label class="mcc-segmented-buttons__button" for="new">
                                                                <span class="mcc-segmented-buttons__label">New</span>
                                                            </label>
                                                            <input type="radio" name="all" id="all" value="all" @click="filterUserType = $event.target.value" :checked="filterUserType =='all'">
                                                            <label class="mcc-segmented-buttons__button" for="all">
                                                                <span class="mcc-segmented-buttons__label">All</span>
                                                            </label>
                                                        </div>
                                                    </fieldset>
                                                </div>
                                            </div>
                                        </div>
                                    </form>

                                    </div>

                                        </div>
                                    </section>
                               
                            </Drawer>
                            <div class="mcc-row mu-mt-03">
                                <div class="mcc-col">
                                    <div class="mcc-card">
                                        <div class="mcc-card__body">
                                            <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                                                <button class="mcc-button mcc-button--outline mcc-button--sm" @click="$refs.customFilter.open()">
                                                    <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                                    <span class="mcc-button__label">Filters {{filterCount > 0 ? ` (${filterCount})` : '(1)'}}</span>
                                                </button>
                                            </div>
                                            <div>
                                                <div>
                                                    <div class="mcc-table-toolbar" v-show="selectedCells.length>0">
                                                        <div class="mcc-table-batch-actions mcc-table-batch-actions--active">
                                                            <div class="mcc-table-batch-actions__summary">
                                                                <p class="mu-mb-00">{{selectedCells.length}} {{ selectedCells.length > 1 ? 'rows selected' : 'row selected'}}</p>
                                                            </div>
                                                            <div class="mcc-table-batch-actions__list">
                                                                <div class="mcc-button-group mcc-button-group--spaced">
                                                                    <button class="mcc-button mcc-button mu-border mu-border-ui-01" @click="showImportUserDialog()" id="importUsers" title="Import users" :disabled="!selectedCells">
                                                                        <mcc-icon name="import" aria-hidden="true"></mcc-icon><span class="mcc-button__label"></span>
                                                                        <label>Import users</label>
                                                                    </button>
                                                                    <button id="cancelBtn" class="mcc-button mcc-button--icon-only mcc-button--sm mcc-button--primary" @click="uncheckAll">
                                                                        <mcc-icon name="cancel" aria-hidden="true"></mcc-icon>
                                                                        <span class="mcc-button__label">Cancel</span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <mcc-data-table ref="usersTable" id="usersTable"></mcc-data-table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

            </div>
        </div>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--warning mcc-dialog--xs" ref="userImportUserDialog" id="userImportUserDialog">
            <form novalidate @submit.prevent="submitImportDialog($event)">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Confirm email setting</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.userImportUserDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mcc-row">
                            <div class="mcc-col">
                                <div>
                                    <div class="mt-2">
                                        <div class="textAlignJustify mu-mb-02">
                                            What should be the email notification setting for the selected users after import? This action would override the email notification setting of existing users.
                                        </div>
                                        <div class="mfc-checkbox-wrapper mfc-form-input-container" id="enableEmailNotification" ref="enableEmailNotification" :checked="enableNotification" @change="enableNotification = $event.target.checked" color="primary">
                                            <input type="checkbox" id="enableEmailNotification" class="mfc-switch">
                                            <label for="enableEmailNotification">Email notification</label>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="$refs.userImportUserDialog.close()">Cancel</button>
                            <button type="submit" class="mcc-button mcc-button--warning">Import</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
</div>
</template>

<script>
import UserAPI from "../../../services/UserAPI";
import constantMessages from "../../../messages";
import Drawer from "../../common/Drawer.vue";
import Table from "@advanced/component-mosaic-table";
import {
    EventBus
} from "../../../services/event-bus";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';
import Utils from "@/script_utils";

export default {
    name: "UserImport",
    components: {
        Drawer
    },

    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["usersgroups.users.import"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            currentPageSize: 10,
            showHelpText: false,
            updateCall: true,
            tableObj: null,
            updateDialog: false,
            importDialog: false,
            filterUserType: "all",
            selectedCells: [],
            userType: "all",
            enableNotification: false,
            tableData: [],
            filterActive: false,
            filterData: [],
            filterCount: 0,
            filterOutOfOffice: "all",
            importUserListSelectionCounter: 0,
        }
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        if (this.$refs.usersTable.isReady) {
            this.initUsersTable();
        } else {
            let self = this;
            this.$refs.usersTable.addEventListener("ready", function () {
                self.initUsersTable();
            });
        }
        this.filterCount = parseInt(localStorage.getItem("setFilterDataInLocalStorage"));
        localStorage.removeItem("setFilterDataInLocalStorage");
        this.initUsersTable();
    },
    methods: {
        getFilterCount() {
            if (this.filterOutOfOffice != "")
                this.filterCount += 1;
        },
        uncheckAll() {
            let self = this;
            const selectedList = document.querySelectorAll("#usersTable input[type=checkbox]:checked");

            selectedList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            self.importUserListSelectionCounter = 0;
            self.selectedCells = [];
        },
        updateOrderList(filteredApplicationList) {
            this.filterData = filteredApplicationList;
            this.filterActive = true;
            this.initUsersTable();

        },
        initUsersTable() {
            let self = this;
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            this.tableObj = window.tableFactory.create(document.getElementById("usersTable"), {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No users found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                fixedHeight: true,
                debounceTime: 1000,
                schema: {
                    properties: {
                        select: {
                            type: "boolean",
                            format: "checkbox",
                            title: "Select",
                            editable: true
                        },
                        username: {
                            type: "string",
                            title: "Username",
                            sortable: true
                        },
                        email: {
                            type: "string",
                            title: "Email",
                            sortable: true,
                            template: '<a href="mailto:{{email}}" class="email-link">{{email}}</a>',
                            columnSearch: false
                        },
                        firstName: {
                            type: "string",
                            title: "First name",
                            sortable: true,
                            columnSearch: false
                        },
                        surname: {
                            type: "string",
                            title: "Surname",
                            sortable: true,
                            columnSearch: false
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        let queryString =
                            "userType=" + self.userType;

                        return UserAPI.getKeycloakUsers(queryString).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                responseData.data = result.data;
                            }
                            self.updateCall = true;
                            self.responseData = responseData.data;
                            self.tableData = responseData.data;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;
                    }
                },
                onAction: (table, action, rowObj) => {
                    if (action == "select") {
                        rowObj.forEach((obj, a) => {
                            if (obj.value && self.selectedCells.indexOf(obj.rowData.id) == -1) {
                                self.selectedCells.push(obj.rowData.id);
                            } else if (!obj.value) {
                                self.selectedCells.splice(self.selectedCells.indexOf(obj.rowData.id), 1);
                            }
                        });

                    }
                },
                // onPageChange: function (table, start, limit) {
                //     if (self.importUserListSelectionCounter === 0) {
                //         const selectedList = document.querySelectorAll("#usersTable input[type=checkbox]:checked");
                //         selectedList.forEach((checkbox) => {
                //             // checkbox.checked = false;
                //         });
                //     }
                // }
            });
        },
        showDialog() {
            this.updateDialog = true;
        },
        showImportDialog() {
            this.importDialog = true;
        },
        resetForm() {
            this.filterCount = 0;
            this.updateCall = false;
            this.userType = "all";
            this.filterUserType = "all";
            this.selectedCells = [];
            this.processTypeRef = "all";
            this.filterOutOfOffice = "all"
            this.initUsersTable();
        },
        closeDialog() {
            this.updateDialog = false;
        },
        closeImportDialog() {
            this.importDialog = false;
        },
        showFilterDialog() {
            this.$refs.userFilterDialog.show();
        },
        showImportUserDialog() {
            this.enableNotification = false;
            this.$refs.userImportUserDialog.show();
            this.showImportDialog()
        },
        submitFilterDialog(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
                
            }
            this.filterCount = 0;
            this.getFilterCount();
            this.userType = this.filterUserType;
            this.selectedCells = [];
            this.initUsersTable();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        submitImportDialog(e) {
            this.importUsers(this.enableNotification);
            this.$refs.userImportUserDialog.close();
        },
        importUsers(enableNotification) {
            let self = this;
            if (self.selectedCells.length > 0) {
                self.updateCall = false;
                let queryStr = "";
                $.each(self.selectedCells, function (key, value) {
                    if (key == 0) {
                        queryStr += "?users[]=" + value;
                    } else {
                        queryStr += "&users[]=" + value;
                    }
                });
                queryStr += "&enableNotification=" + enableNotification;
                self.selectedCells = [];
                UserAPI.updateKeycloakUsers(queryStr).then(result => {
                    self.updateCall = true;
                    self.initUsersTable();
                    if (result.type == "SUCCESS") {
                        EventBus.$emit("success-notification", {
                            msg: result.text
                        });
                    } else {
                        EventBus.$emit('error-notification', {
                            "msg": result.text
                        });
                    }
                });
            }
        }

    },
}
</script>
